import { oneOf } from "prop-types";

import FundItLogo from "UI/images/FundItLogo";
import UnoHeadset from "UI/images/UnoHeadset";
import UnoLogo from "UI/images/UnoLogo";
import BulletFilled from "UI/images/customIcons/BulletFilled";
import BulletOutline from "UI/images/customIcons/BulletOutline";
import {
  HouseholdDataEntry,
  HouseholdSignedUp,
  HouseholdUpdated,
} from "UI/images/customIcons/HouseholdGlyphs";
import RadioDot from "UI/images/customIcons/RadioDot";
import CircleFilled from "UI/images/virtueIcons/CircleFilled";
import CircleOutline from "UI/images/virtueIcons/CircleOutline";
import DottedLine from "UI/images/virtueIcons/DottedLine";
import Heart from "UI/images/virtueIcons/Heart";
import Plus from "UI/images/virtueIcons/Plus";
import SqigglyLine from "UI/images/virtueIcons/SqigglyLine";
import Square from "UI/images/virtueIcons/Square";
import SquareFilled from "UI/images/virtueIcons/SquareFilled";
import Sun from "UI/images/virtueIcons/Sun";
import SunNoRays from "UI/images/virtueIcons/SunNoRays";
import TriangleFilled from "UI/images/virtueIcons/TriangleFilled";
import TriangleOutline from "UI/images/virtueIcons/TriangleOutline";
import UpArrow from "UI/images/virtueIcons/UpArrow";

const customIconKeys = {
  fundIt: "fundIt",
  uno: "uno",
  "uno headset": "uno headset",
  veracity: "veracity",
  "veracity far": "veracity far",
  hope: "hope",
  "hope rays": "hope rays",
  wisdom: "wisdom",
  justice: "justice",
  humility: "humility",
  "humility far": "humility far",
  courage: "courage",
  "courage far": "courage far",
  temperance: "temperance",
  patience: "patience",
  love: "love",
  faith: "faith",
  bullet: "bullet",
  "bullet far": "bullet far",
  "radio-dot": "radio-dot",
  "household signed up": "household signed up",
  "household updated": "household updated",
  "household data entry": "household data entry",
};

const customIcons = {
  [customIconKeys.fundIt]: FundItLogo,
  [customIconKeys.uno]: UnoLogo,
  [customIconKeys["uno headset"]]: UnoHeadset,
  [customIconKeys.veracity]: TriangleFilled,
  [customIconKeys["veracity far"]]: TriangleOutline,
  [customIconKeys.hope]: SunNoRays,
  [customIconKeys["hope rays"]]: Sun,
  [customIconKeys.wisdom]: UpArrow,
  [customIconKeys.justice]: UpArrow, // rotated 90 degrees
  [customIconKeys.humility]: CircleFilled,
  [customIconKeys["humility far"]]: CircleOutline,
  [customIconKeys.courage]: Square,
  [customIconKeys["courage far"]]: SquareFilled,
  [customIconKeys.temperance]: SqigglyLine,
  [customIconKeys.patience]: DottedLine,
  [customIconKeys.love]: Heart,
  [customIconKeys.faith]: Plus,
  [customIconKeys.bullet]: BulletFilled,
  [customIconKeys["bullet far"]]: BulletOutline,
  [customIconKeys["radio-dot"]]: RadioDot,
  [customIconKeys["household signed up"]]: HouseholdSignedUp,
  [customIconKeys["household updated"]]: HouseholdUpdated,
  [customIconKeys["household data entry"]]: HouseholdDataEntry,
};

/**
 * Sized and colored by the text around it, like an fa icon, and right on its
 * first commit -- the Change Log clones and measures rows on that commit.
 * @param {object} param0
 * @param {string} param0.icon
 */
const CustomIcon = ({ icon }) => {
  const Icon = customIcons[icon];

  const rotation = icon === customIconKeys.justice ? 90 : undefined;

  return <Icon rotation={rotation} size="1em" color="currentColor" />;
};

CustomIcon.propTypes = {
  icon: oneOf(Object.keys(customIcons)).isRequired,
};

export { customIconKeys };
export default CustomIcon;
